import { atom } from "jotai";
import { map, flip, has, pipe, pick, includes } from "ramda";

export const project_atom = atom({ is_selecting_ad_account: false });
export const projects_atom = atom([]);
